import * as ActionTypes from '../actionTypes';

const initialState = {
    data: [],
    listBankCodeType: {
        sortCode: 'Sort Code',
        aba: 'ABA',
        bsbCode: 'BSB Code',
        institutionNo: 'Institution No',
        bankCode: 'Bank Code',
        branchCode: 'Branch Code',
        clabe: 'Clabe',
        cnaps: 'Cnaps',
        ifsc: 'IFSC',
        iban: 'IBAN',
        bicSwift: 'SWIFT / BIC Code',
        billerCode: 'Biller Code',
        payId: 'PayID',
        bankAndBranchCode: 'bank number and bank branch',
    },
    bankCodes: [
        'bicSwift',
        'iban',
        'sortCode',
        'aba',
        'bsbCode',
        'institutionNo',
        'bankCode',
        'branchCode',
        'clabe',
        'cnaps',
        'ifsc',
        'billerCode',
    ],
    checkBankDetails: ['iban', 'bicSwift', 'sortCode', 'aba', 'bsbCode', 'routingNumber', 'cnaps', 'ifsc'],
    bankDetails: {
        iban: 'iban',
        bicSwift: 'bic_swift',
        sortCode: 'sort_code',
        aba: 'aba',
        bsbCode: 'bsb_code',
        routingNumber: 'routing_number',
        cnaps: 'cnaps',
        ifsc: 'ifsc',
    },
    conflictFields: [],
    beneficiaryData: {},
    nextPage: undefined,
};

export default function reducer(state = initialState, action) {
    let object;
    switch (action.type) {
        case ActionTypes.COMPLETE_GET_BENEFICIARY_LISTV2:
            const { beneficiaries, nextPage } = action.payload;
            return {
                ...state,
                data: [...state.data, ...beneficiaries],
                nextPage,
            };
        case ActionTypes.COMPLETE_GET_BENEFICIARY_LIST:
            object = {
                data: action.payload,
            };
            return { ...state, ...object };
        case ActionTypes.SET_CONFLICT_FIELDS:
            object = {
                conflictFields: action.payload,
            };
            return { ...state, ...object };
        case ActionTypes.SET_BENEFICIARY_DATA:
        case ActionTypes.COMPLETE_CREATE_BENEFICIARY:
            object = {
                beneficiaryData: action.payload,
            };
            return { ...state, ...object };
        default:
            return state;
    }
}
